import React from "react";

const AdInspire = (props) => {
  return (
    <div {...props}>
      <div className="alert alert-light text-center">
        <p
          className="text-dark mt-n2 mr-n2 mb-1 text-right"
          style={{ fontSize: "small" }}
        >
          <i class="fas fa-ad"></i> by Inspire
          {/* <i class="fa fa-times"></i> */}
        </p>
        <strong>INSPIRE Code & Graphics</strong>
        <p class="my-2">
          Coding + Graphics{" "}
          <u>
            <b>INSPIRE</b>
          </u>
        </p>
        <a
          class="btn btn-black px-2 btn-block btn-sm mb-0"
          href="/"
          role="button"
        >
          EXPLORE <i class="fas fa-gem ml-2"></i>
        </a>
      </div>
    </div>
  );
};

export default AdInspire;
